<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}"  (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>

<div class="board-page inner-wrap">
  <div class="board-header clearfix">
    <div class="view-type-btn fl mr5">
      <button type="button" *ngIf="boardInfo.lvt_list == '1'" class="btn list-btn" [ngClass]="{active:params.view_type=='list'}" (click)="viewChange('list')"></button>
      <button type="button" *ngIf="boardInfo.lvt_album == '1'" class="btn album-btn" [ngClass]="{active:params.view_type=='album'}" (click)="viewChange('album')"></button>
      <button type="button" *ngIf="boardInfo.lvt_gallery == '1'" class="btn gallery-btn" [ngClass]="{active:params.view_type=='gallery'}" (click)="viewChange('gallery')"></button>
      <button type="button" *ngIf="boardInfo.lvt_calendar == '1'" class="btn album-btn" [ngClass]="{active:params.view_type=='calendar'}" (click)="viewChange('calendar')"></button>
    </div>
    <div class="rowcnt">{{'BOARD.SEARCH_TOTAL1' | translate}} <span>{{params.totalCount | number}}</span> {{'BOARD.SEARCH_TOTAL2' | translate}}</div>
    
    <div class="search">
      <div class="select cp mr10" [ngClass]="{on: isSelectRow}" (click)="isSelectRow=!isSelectRow" (mouseleave)="isSelectRow=false">
        <div class="selected-item">{{params.row}} {{'BOARD.LINE' | translate}}</div>       
        <ul class="select-item">
          <li *ngFor="let cnt of linecnt" (click)="selectParams('row', cnt)">{{cnt}} {{'BOARD.LINE' | translate}}</li>
        </ul>
      </div>
      <div class="select cp" [ngClass]="{on: isSelectOnA}" (click)="isSelectOnA=!isSelectOnA" (mouseleave)="isSelectOnA=false">
        <div class="selected-item">{{isSelectTxtA | translate}}</div>       
        <ul class="select-item">
          <li (click)="selectSearchGroup('')">{{'BOARD.SEARCH_GROUP1' | translate}}</li>
          <li (click)="selectSearchGroup('subject')">{{'BOARD.SEARCH_GROUP2' | translate}}</li>
          <li (click)="selectSearchGroup('contents')">{{'BOARD.SEARCH_GROUP3' | translate}}</li>
          <li (click)="selectSearchGroup('writer')">{{'BOARD.SEARCH_GROUP4' | translate}}</li>          
        </ul>
      </div>
      <input type="text" class="input-txt" (change)="changeText($event)" (keyup)="search($event)" />
      <button class="search-btn" (click)="getBoardList()">{{'BOARD.SEARCH_BUTTON1' | translate}}</button>
      <button class="reset-btn" (click)="initSearch()">{{'BOARD.SEARCH_BUTTON2' | translate}}</button>
      <button *ngIf="authWriteCheck()" class="write-btn" (click)="write()">{{'BOARD.SEARCH_BUTTON3' | translate}}</button>
    </div>
      
  </div> 

  <app-board-list *ngIf="params.type=='list'" [boardInfo]="boardInfo" [memberInfo]="memberInfo" [data]="data" [groupTab]="groupTab" [params]="params" [authCheck$]="authCheck$"></app-board-list>
  <app-board-write *ngIf="params.type=='write' || params.type=='modify'" [boardInfo]="boardInfo" [memberInfo]="memberInfo" [data]="data" [groupTab]="groupTab" [params]="params" [authCheck$]="authCheck$"></app-board-write>
  <app-board-reply *ngIf="params.type=='reply'"></app-board-reply>
</div>

<app-footer></app-footer>
